import authHeader from "./auth-header";
import {axiosInstance} from '../main.js';

const API_URL_FETCH_INSPECTION_CASES = process.env.VUE_APP_ROOT_API+'inspectionCasesList/';
const API_URL_FETCH_INSPECTION_WORK_ORDERS = process.env.VUE_APP_ROOT_API+'inspectionWorkOrdersList/';
const API_URL_FETCH_MY_INSPECTION_WORK_ORDERS = process.env.VUE_APP_ROOT_API+'myInspectionWorkOrdersList/';
const API_URL_FETCH_CHECKLISTS_PER_INSPECTION_REPORT = process.env.VUE_APP_ROOT_API+'checklistsPerInspectionReport/';
const API_URL_UPDATE_CHECKLISTS_PER_INSPECTION_REPORT = process.env.VUE_APP_ROOT_API+'updateChecklistPerInspectionReport/';
const API_URL_FETCH_INSPECTION_REPORT_DETAILS = process.env.VUE_APP_ROOT_API+'getInspectionReportDetails/';
const API_URL_FETCH_INSPECTION_CONCLUSION_DETAILS = process.env.VUE_APP_ROOT_API+'getInspectionConclusionDetails/';
const API_URL_FETCH_FILTERED_DATA_BY_INSPECTION_CASE = process.env.VUE_APP_ROOT_API+'filteredDataByInspectionCase/';
const API_URL_CREATE_INSPECTION_CONFIRMATION = process.env.VUE_APP_ROOT_API+'createInspectionConfirmation/';
const API_URL_FETCH_INSPECTION_CONFIRMATION = process.env.VUE_APP_ROOT_API+'inspectionConfirmationDetails/';
const API_URL_FETCH_INSPECTION_REPORT = process.env.VUE_APP_ROOT_API+'inspectionReportId/';
const API_URL_FETCH_INSPECTION_REPORTS = process.env.VUE_APP_ROOT_API+'inspectionReportsList/';
const API_URL_FETCH_INSPECTION_CONCLUSIONS = process.env.VUE_APP_ROOT_API+'inspectionConclusionsList/';
const API_URL_FETCH_PAYMENT_ORDER = process.env.VUE_APP_ROOT_API+'paymentOrderPerInspectionReport/';
const API_URL_UPDATE_PAYMENT_ORDER = process.env.VUE_APP_ROOT_API+'updatePaymentOrderPerInspectionReport/';
const API_URL_FETCH_INSPECTION_CASES_LIST = process.env.VUE_APP_ROOT_API+'myInspectionCasesList/';
const API_URL_FETCH_INSPECTION_CASES_BY_SUBJECTID = process.env.VUE_APP_ROOT_API+'inspectionCasesListBySubject/';
const API_URL_FETCH_INSPECTION_CASES_DETAILS_SUBSIDIARY = process.env.VUE_APP_ROOT_API+'admin/subjectDetailsSubsidiariesList/';

class InspectionProcedureService {
    getAllInspectionCases(inspectionCasesParams) {
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CASES, {
                headers:
                    authHeader(),
                params: {
                    sequenceNumber: inspectionCasesParams ? inspectionCasesParams.sequenceNumber : null,
                    archiveNumber: inspectionCasesParams ? inspectionCasesParams.archiveNumber : null,
                    assignedTo: (inspectionCasesParams && inspectionCasesParams.assignedTo) ? inspectionCasesParams.assignedTo.id : null,
                    createdBy: (inspectionCasesParams && inspectionCasesParams.createdBy) ? inspectionCasesParams.createdBy.id : null,
                    status: inspectionCasesParams ? inspectionCasesParams.status : null,
                    institutionId: (inspectionCasesParams && inspectionCasesParams.institution) ? inspectionCasesParams.institution.id : null,
                    sectorId: (inspectionCasesParams && inspectionCasesParams.sector) ? inspectionCasesParams.sector.id : null,
                    createdDates: inspectionCasesParams ? inspectionCasesParams.createdDates : null,
                    taxNumber: inspectionCasesParams ? inspectionCasesParams.taxNumber : null,
                    companyRegistrationNumber: inspectionCasesParams ? inspectionCasesParams.companyRegistrationNumber : null,
                }
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }
    inspectionCasesListBySubject(inspectionCasesParams) {
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CASES_BY_SUBJECTID, {
                headers:
                    authHeader(),
                params: {
                    subjectId: inspectionCasesParams ? inspectionCasesParams.subjectId : null,
                    subjectSubsidiaryId: inspectionCasesParams ? inspectionCasesParams.subjectSubsidiaryId : null,
                }
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }
    getSubjectDetailsSubsidiariesList(inspectionCasesParams){
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CASES_DETAILS_SUBSIDIARY, {
                headers:
                    authHeader(),
                params: {
                    subjectId: inspectionCasesParams ? inspectionCasesParams.subjectId : null,
                }
            })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }
    getMyInspectionCasesList() {
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CASES_LIST, {
                headers:
                    authHeader(),
                params: { }
            })
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getAllInspectionWorkOrders(inspectionWorkOrdersParams) {

        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_WORK_ORDERS, {
                headers:
                    authHeader(),
                params: {
                    archiveNumber: inspectionWorkOrdersParams ? inspectionWorkOrdersParams.archiveNumber : null,
                    assignedTo: (inspectionWorkOrdersParams && inspectionWorkOrdersParams.assignedTo) ? inspectionWorkOrdersParams.assignedTo.id : null,
                    createdBy: (inspectionWorkOrdersParams && inspectionWorkOrdersParams.createdBy) ? inspectionWorkOrdersParams.createdBy.id : null,
                    institutionId: (inspectionWorkOrdersParams && inspectionWorkOrdersParams.institution) ? inspectionWorkOrdersParams.institution.id : null,
                    sectorId: (inspectionWorkOrdersParams && inspectionWorkOrdersParams.sector) ? inspectionWorkOrdersParams.sector.id : null,
                    workOrderDates: inspectionWorkOrdersParams ? inspectionWorkOrdersParams.workOrderDates : null,
                    inspectionCheckDates: inspectionWorkOrdersParams ? inspectionWorkOrdersParams.inspectionCheckDates : null,
                }
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }

    getMyInspectionWorkOrders() {
        return axiosInstance
            .get(API_URL_FETCH_MY_INSPECTION_WORK_ORDERS, {
                headers:
                    authHeader(),
                params: { }
            })
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getReportChecklists(id){
        return axiosInstance
            .get(API_URL_FETCH_CHECKLISTS_PER_INSPECTION_REPORT, {
                headers:
                    authHeader(),
                params: {inspectionWorkOrderId: id}
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }

    updateInspectionReportChecklist(checklist, inspectionReportId, inspectionFindings) {

        let checks = [];
            checklist.checks.forEach(function (value) {
                checks.push(value);
                if(value.subjectAnswer === 'no'){
                    inspectionFindings = inspectionFindings != undefined ? inspectionFindings.concat("\n", value.penaltyProvisions) : value.penaltyProvisions;
                }
            });

        return axiosInstance
            .post(API_URL_UPDATE_CHECKLISTS_PER_INSPECTION_REPORT, {
                    checklistId: checklist.id,
                    checks: checks,
                    inspectionReportId: inspectionReportId,
                    inspectionFindings: inspectionFindings
                },
                {
                    headers: authHeader()
                })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if(err.response){
                    window.console.log(err.response.status);
                    window.console.log(err.response.data.message);
                    window.console.log(err.response.data.label);
                    if(err.response.status == 405) {
                        let error = {};
                        error.message = err.response.data;
                        error.status = err.response.status;
                        return error;
                    }
                    return err.response;
                }
            });
    }

    getInspectionReportDetails(inspectionReportInfo, inspectionWorkOrderId, inspectionReportId) {
        // window.console.log(inspectionReportInfo);
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_REPORT_DETAILS, {
                headers:
                    authHeader(),
                params: {
                    inspectionReportId: inspectionReportId,
                    inspectionWorkOrderId: inspectionWorkOrderId,
                    institution: inspectionReportInfo.institution,
                    sector: inspectionReportInfo.sector,
                    subject: inspectionReportInfo.subject,
                    subjectSubsidiary: inspectionReportInfo.subjectSubsidiary,
                    assignedTo: inspectionReportInfo.assignedTo
                }
            })
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getInspectionConclusionDetails(inspectionConclusionInfo, inspectionWorkOrderId) {
        // window.console.log(inspectionConclusionInfo);
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CONCLUSION_DETAILS, {
                headers:
                    authHeader(),
                params: {
                    inspectionWorkOrderId: inspectionWorkOrderId,
                    institution: inspectionConclusionInfo.institution,
                    sector: inspectionConclusionInfo.sector,
                    subject: inspectionConclusionInfo.subject,
                    subjectSubsidiary: inspectionConclusionInfo.subjectSubsidiary,
                    assignedTo: inspectionConclusionInfo.assignedTo
                }
            })
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getFilteredDataByInspectionCase(inspectionCaseId) {

        return axiosInstance
            .get(API_URL_FETCH_FILTERED_DATA_BY_INSPECTION_CASE, {
                headers: authHeader(), params: {recordId: inspectionCaseId}
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }

    createInspectionConfirmation(inspectionConfirmation) {

        return axiosInstance
            .post(API_URL_CREATE_INSPECTION_CONFIRMATION, {
                    delete: inspectionConfirmation.deleted != null ? inspectionConfirmation.deleted : false,
                    recordId: inspectionConfirmation.id != null ? inspectionConfirmation.id : null,
                    archiveNumber: inspectionConfirmation.archiveNumber,
                    archiveDate: inspectionConfirmation.archiveDate,
                    itgInspectionReportId: inspectionConfirmation.itgInspectionRepordId,
                    confiscationDate: inspectionConfirmation.confiscationDate,
                    confiscatedFromFirstName: inspectionConfirmation.confiscatedFromFirstName,
                    confiscatedFromLastName: inspectionConfirmation.confiscatedFromLastName,
                    bornAtDate: inspectionConfirmation.bornAtDate,
                    bornInCity: inspectionConfirmation.bornInCity,
                    livesInCity: inspectionConfirmation.livesInCity,
                    livesOnAddress: inspectionConfirmation.livesOnAddress,
                    livesOnAddressNumber: inspectionConfirmation.livesOnAddressNumber,
                    personalId: inspectionConfirmation.personalId,
                    inspectionConfirmationItems: inspectionConfirmation.inspectionConfirmationItems,
                },
                {
                    headers: authHeader()
                })
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getInspectionReportByWorkOrder(inspectionWorkOrderId) {

        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_REPORT, {headers: authHeader(), params: {inspectionWorkOrderId: inspectionWorkOrderId}})
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getInspectionConfirmation(inspectionReportId) {

        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CONFIRMATION, {headers: authHeader(), params: {inspectionReportId: inspectionReportId}})
            .then(response => {
                return response.data;
            })
            .catch(err => window.console.log(err));
    }

    getAllInspectionReports(inspectionReportsParams) {
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_REPORTS, {
                headers:
                    authHeader(),
                params: {
                    archiveNumber: inspectionReportsParams ? inspectionReportsParams.archiveNumber : null,
                    institutionId: (inspectionReportsParams && inspectionReportsParams.institution) ? inspectionReportsParams.institution.id : null,
                    sectorId: (inspectionReportsParams && inspectionReportsParams.sector) ? inspectionReportsParams.sector.id : null,
                    createdBy: (inspectionReportsParams && inspectionReportsParams.createdBy) ? inspectionReportsParams.createdBy.id : null,
                    assignedTo: (inspectionReportsParams && inspectionReportsParams.assignedTo) ? inspectionReportsParams.assignedTo.id : null,
                    createdReportDates: inspectionReportsParams ? inspectionReportsParams.createdReportDates : null,
                    inspectionCheckStartDates: inspectionReportsParams ? inspectionReportsParams.inspectionCheckStartDates : null,
                    inspectionCheckType: (inspectionReportsParams && inspectionReportsParams.inspectionCheckType) ? inspectionReportsParams.inspectionCheckType.id : null,
                    irregularitiesFound: (inspectionReportsParams && inspectionReportsParams.irregularitiesFound) ? inspectionReportsParams.irregularitiesFound.id : null,
                }
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }

    getAllInspectionConclusions(inspectionConclusionsParams) {
        return axiosInstance
            .get(API_URL_FETCH_INSPECTION_CONCLUSIONS, {
                headers:
                    authHeader(),
                params: {
                    archiveNumber: inspectionConclusionsParams ? inspectionConclusionsParams.archiveNumber : null,
                    institutionId: (inspectionConclusionsParams && inspectionConclusionsParams.institution) ? inspectionConclusionsParams.institution.id : null,
                    sectorId: (inspectionConclusionsParams && inspectionConclusionsParams.sector) ? inspectionConclusionsParams.sector.id : null,
                    createdBy: (inspectionConclusionsParams && inspectionConclusionsParams.createdBy) ? inspectionConclusionsParams.createdBy.id : null,
                    assignedTo: (inspectionConclusionsParams && inspectionConclusionsParams.assignedTo) ? inspectionConclusionsParams.assignedTo.id : null,
                    inspectionCheckType: (inspectionConclusionsParams && inspectionConclusionsParams.inspectionCheckType) ? inspectionConclusionsParams.inspectionCheckType.id : null,
                    inspectionMeasuresFound: (inspectionConclusionsParams && inspectionConclusionsParams.inspectionMeasuresFound) ? inspectionConclusionsParams.inspectionMeasuresFound.id : null,
                    inspectionMeasuresDueDates: inspectionConclusionsParams ? inspectionConclusionsParams.inspectionMeasuresDueDates : null,
                }
            })
            .then(response => {
                return response.data;

            })
            .catch(err => {
                if(err.response && err.response.status == 405) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }

    getPaymentOrderDetails(inspectionReportId) {
        return axiosInstance
            .get(API_URL_FETCH_PAYMENT_ORDER, {
                headers:
                    authHeader(),
                params: {
                    inspectionReportId: inspectionReportId,
                 }
            })
            .then(response => {
                // window.console.log(response.data);
                return response.data;

            })
            .catch(err => {
                if(err.response) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }

    updatePaymentOrder(paymentOrderDetails, inspectionReportId){
        return axiosInstance
            .post(API_URL_UPDATE_PAYMENT_ORDER, {
                    paymentOrderDetails: paymentOrderDetails,
                    itgInspectionReportId: inspectionReportId,
                },
                {
                    headers: authHeader()
                })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if(err.response) {
                    let error = {};
                    error.message = err.response.data;
                    error.status = err.response.status;
                    return error;
                }
            });
    }
}

export default new InspectionProcedureService();
